"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderBaseData = getOrderBaseData;
exports.getOrderSaleStsList = getOrderSaleStsList;
exports.getRevenueAndVolumeTrends = getRevenueAndVolumeTrends;
exports.getSceneStack = getSceneStack;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getOrderBaseData(data) {
  return (0, _requestPIM.default)({
    data: data,
    url: '/orderDataStatistics/getOrderBaseData',
    method: 'post'
  });
}
function getOrderSaleStsList(data) {
  return (0, _requestPIM.default)({
    data: data,
    url: '/orderDataStatistics/getOrderSaleStsList',
    method: 'post'
  });
}
function getRevenueAndVolumeTrends(data) {
  return (0, _requestPIM.default)({
    data: data,
    url: '/orderDataStatistics/getRevenueAndVolumeTrends',
    method: 'post'
  });
}
function getSceneStack(data) {
  return (0, _requestPIM.default)({
    data: data,
    url: '/orderDataStatistics/getSceneStack',
    method: 'post'
  });
}